import { AbstractControl } from '@angular/forms';
import { ValidationResult } from './validation-result';

export class PhoneValidator {
  static validatePhone(control: AbstractControl): ValidationResult {
    const value = control.value && control.value.replace(/[^0-9.]/g, '');

    if (control.value && !value) {
      return { 'invalidPhone': true };
    }

    if (!value || value.length >= 10) {
      return null;
    }

    return { 'invalidPhone': true };
  }
};
